import { Autocomplete, Grid, TextField } from "@mui/material";
import React from "react";
import { ProjectListDto } from "~/api/GeneratedApi";
import { useProjectMap } from "~/pages/ProjectsPage/hooks/useProjectMap";
import { useProjectQuery } from "~/pages/ProjectsPage/hooks/useProjectQuery";
import { CustomSlider, useSlider } from "~/utils/hooks/useSlider";

export const ProjectExtraSettings = () => {
  // TODO tämä on kesken (atm piilotettu pääkartalta)

  const { projects } = useProjectQuery();
  const { setSliderValue, sliderValue } = useSlider();
  const [selectedProjectId, setSelectedProjectId] = React.useState<number>();

  useProjectMap({
    sliderValue,
    id: selectedProjectId,
  });

  const defaultProps = {
    options: projects ?? [],
    getOptionLabel: (option: ProjectListDto) => option?.name ?? "",
  };
  const marks = [1, 2, 4, 5].map((f, index) => ({
    value: index,
    label: f.toString(),
  }));
  return (
    <Grid item>
      <Autocomplete
        sx={{ width: "100%" }}
        {...defaultProps}
        renderInput={(params) => (
          <TextField
            sx={{ width: "400px" }}
            {...params}
            label="pick a project"
          />
        )}
        onChange={(_e, v) => setSelectedProjectId(v?.id)}
      />
      <CustomSlider
        customMarks={marks}
        setSliderValue={setSliderValue}
        sliderValue={sliderValue}
        step={null}
        max={marks.length - 1}
      />
    </Grid>
  );
};
